// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CardValidations.bs.js";

function updateCardBody(paymentMethodToken, nickName, cardHolderName) {
  var cardDetails = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
        [
          "card_holder_name",
          cardHolderName
        ],
        [
          "nick_name",
          nickName
        ]
      ]);
  var paymentMethodData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          "card",
          cardDetails
        ]]);
  return [
          [
            "payment_method_token",
            paymentMethodToken
          ],
          [
            "payment_method_data",
            paymentMethodData
          ]
        ];
}

function updateCVVBody(paymentMethodToken, cvcNumber) {
  var cardDetails = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          "card_cvc",
          cvcNumber
        ]]);
  var paymentMethodData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          "card",
          cardDetails
        ]]);
  return [
          [
            "payment_method_token",
            paymentMethodToken
          ],
          [
            "payment_method_data",
            paymentMethodData
          ]
        ];
}

function vaultUpdateCVVBody(cvcNumber) {
  var cardDetails = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          "card_cvc",
          cvcNumber
        ]]);
  var paymentMethodData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          "card",
          cardDetails
        ]]);
  return [[
            "payment_method_data",
            paymentMethodData
          ]];
}

function saveCardBody(cardNumber, month, year, cardHolderNameOpt, cvcNumber, cardBrand, nicknameOpt) {
  var cardHolderName = cardHolderNameOpt !== undefined ? Caml_option.valFromOption(cardHolderNameOpt) : undefined;
  var nickname = nicknameOpt !== undefined ? nicknameOpt : "";
  var cardBody = [
    [
      "card_number",
      CardValidations$OrcaPaymentPage.clearSpaces(cardNumber)
    ],
    [
      "card_exp_month",
      month
    ],
    [
      "card_exp_year",
      year
    ],
    [
      "card_cvc",
      cvcNumber
    ]
  ];
  Core__Option.map(cardHolderName, (function (name) {
          cardBody.push([
                "card_holder_name",
                name
              ]);
        }));
  if (nickname !== "") {
    cardBody.push([
          "nick_name",
          nickname
        ]);
  }
  return [
          [
            "payment_method_type",
            "card"
          ],
          [
            "payment_method_subtype",
            "card"
          ],
          [
            "payment_method_data",
            Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                    "card",
                    Utils$OrcaPaymentPage.getJsonFromArrayOfJson(cardBody.concat(cardBrand))
                  ]])
          ]
        ];
}

export {
  updateCardBody ,
  updateCVVBody ,
  vaultUpdateCVVBody ,
  saveCardBody ,
}
/* Utils-OrcaPaymentPage Not a pure module */
